<template>
  <div class="main">
    <div class="main_right">
      <div class="page_info">
        <Breadcrumb class="breadcrumb">
          <BreadcrumbItem>我的设备</BreadcrumbItem>
        </Breadcrumb>
        <div class="searchBox">
          <div>
            <Select v-model="reqbody.deviceManufacture" style="width:120px;" placeholder="设备厂家" clearable @on-change="search" @on-clear="search">
              <Option v-for="item in deviceManufactureList" :value="item.label" :key="item.label">{{ item.value }}</Option>
            </Select>
            <Select v-model="searchDeviceStatus" style="width:120px;margin-left: 15px;" placeholder="设备状态" clearable>
              <Option v-for="item in deviceStatus" :value="item.label" :key="item.label">{{ item.value }}</Option>
            </Select>
            <Select v-model="reqbody.devicePurpose" style="width:120px;margin-left: 15px;" placeholder="设备用途" clearable @on-change="search" @on-clear="search">
              <Option v-for="item in devicePurposeList" :value="item.label" :key="item.label">{{ item.value }}</Option>
            </Select>
            <Select v-model="reqbody.deviceVersionNo" style="width:120px;margin-left: 15px;" placeholder="版本号" clearable @on-change="search" @on-clear="search">
              <Option v-for="item in firewareList" :value="item.firmwareNo" :key="item.firmwareNo">{{ item.firmwareNo }}</Option>
            </Select>
            <Select v-model="reqbody.manufacturer" style="width:220px;margin-left: 15px;" placeholder="合作伙伴" clearable @on-change="search" @on-clear="search">
              <Option v-for="item in partnerNameList" :value="item.partnerName" :key="item.partnerName">{{ item.partnerName }}</Option>
            </Select>
            <Select v-model="reqbody.campusName" style="width:220px;margin-left: 15px;" placeholder="商户名称" clearable @on-change="search" @on-clear="search">
              <Option v-for="item in merchantNameList" :value="item.merchantName" :key="item.merchantName">{{ item.merchantName }}</Option>
            </Select>
          </div>
          <div>
            <Input v-model="reqbody.deviceNo" icon="ios-search" placeholder="设备编号" :maxlength=32 style="width: 200px" @on-click="search" @keyup.13.native="search"/>
          </div>
        </div>

        <div class="operationBox">
          <div>
            <!--<Button type="primary" icon="plus" @click="toAddDevice">添加</Button>-->
            <Button type="info" icon="arrow-graph-up-right" @click="batchUpdata" v-if="authList.indexOf('001006') !== -1">批量升级</Button>
            <!--<Button type="error" icon="minus" @click="batchDelete">删除</Button>-->
          </div>
          <div>
            <!--<Upload :action="action" ref="upload" style="display: inline-block;" :show-upload-list='upFileList' :before-upload="beforeUpload" :on-success="uploadSuccess">-->
              <!--<Button type="ghost" icon="ios-cloud-upload-outline">导入</Button>-->
            <!--</Upload>-->
            <Button type="ghost" icon="ios-cloud-download-outline" @click="exportDevice" v-if="authList.indexOf('001008') !== -1">导出</Button>
          </div>
        </div>
        <Table border height="520" ref="upgrade_table" :columns="columns" :data="tableData" @on-select-all="setAllBatch" @on-select="setBatch" @on-select-cancel="delBatch"></Table>
        <page :total="total" show-sizer class="table_page" @on-change="changePageNo" @on-page-size-change="changePageSize" show-total></page>
      </div>
    </div>

    <Modal
      v-model="openSimple"
      title="提示"
      @on-ok="sureDelete"
      @on-cancel="cancelDelete">
      <p>是否确认删除设备？</p>
    </Modal>

    <Modal
      v-model="updataSimple"
      title="请选择升级版本号"
      @on-ok="sureUpdata"
      @on-cancel="cancelUpdata">
      <Select v-model="upgradeVersionNo" style="display: block; width:200px; margin: 30px auto;">
        <Option v-for="item in upgradeVersionNoList" :value="item.versionNo" :key="item.versionNo">{{ item.versionNo }}</Option>
      </Select>
    </Modal>
  </div>
</template>

<script>
import NavList from '../nav-list/nav-list'
import TopOpe from '../top-ope/top-ope'
import {nSuccess, nError} from '../../util/notice'
import {errorHandler} from '../../util/errorHandler'
import {httpUrl} from '../../api'
import {getAuthStr} from '../../util/bus'

export default {
  components: {
    TopOpe,
    NavList},
  name: 'upgrade-management',
  data () {
    return {
      authList: '',
      updataSimple: false,
      openSimple: false,
      searchDeviceStatus: '',
      deviceStatus: [
        {label: '0', value: '离线'},
        {label: '1', value: '在线'}
      ],
      devicePurposeList: [
        {label: '1', value: '门禁'},
        {label: '2', value: '停车'}
      ],
      firewareList: [],
      partnerNameList: [],
      merchantNameList: [],
      deviceManufactureList: [
        {label: '大麦物联', value: '大麦物联'},
        {label: '宇视', value: '宇视'},
        {label: '大华', value: '大华'}
      ],
      reqbody: {
        pageSize: 10,
        pageNo: 1,
        manufacturer: '',
        campusName: '',
        deviceVersionNo: '',
        deviceNo: '',
        deviceStatus: '-1',
        deviceManufacture: ''
      },
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        }, {
          title: '设备厂家',
          align: 'center',
          key: 'deviceManufacture',
          width: 90,
        }, {
          title: '设备用途',
          align: 'center',
          key: 'devicePurposeText',
          width: 90,
        }, {
          title: '设备编号',
          align: 'center',
          key: 'deviceNo',
          width: 120,
        }, {
          title: '合作伙伴',
          key: 'manufacturer',
          align: 'center',
          width: 120,
        }, {
          title: '设备状态',
          key: 'deviceStatus',
          width: 90,
          align: 'center',
          render: (h, params) => {
            if (params.row.deviceStatus === '1') {
              return h('div', [
                h('Icon', {
                  style: {
                    color: '#19be6b',
                    fontSize: '16px'
                  },
                  props: {
                    type: 'record'
                  }
                })
              ])
            } else {
              return h('div', [
                h('Icon', {
                  style: {
                    color: '#ed3f14',
                    fontSize: '16px'
                  },
                  props: {
                    type: 'record'
                  }
                })
              ])
            }
          }
        }, {
          title: '设备型号',
          key: 'deviceType',
          align: 'center',
          width: 120,
        }, {
          title: '维保时间',
          key: 'maintenanceTime',
          align: 'center',
          width: 120,
        }, {
          title: '服务时间',
          key: 'serviceTime',
          align: 'center',
          width: 200,
        }, {
          title: '商户名称',
          key: 'campusName',
          align: 'center',
          width: 120,
        }, {
          title: '商户简称',
          width: 90,
          key: 'campusShortName',
          align: 'center'
        }, {
          title: '版本号',
          key: 'deviceVersionNo',
          align: 'center',
          width: 120,
        }, {
          title: '设备场景',
          width: 90,
          key: 'sceneText',
          align: 'center'
        }, {
          title: '操作',
          width: 160,
          key: 'operation',
          fixed: 'right',
          align: 'center',
          render: (h, params) => {
            if (params.row.authStatus) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.modifyDev(params.row.id)
                    }
                  }
                }, '修改'),
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.updataDev(params.row.id)
                    }
                  }
                }, '升级'),
                // h('Button', {
                //   props: {
                //     type: 'error',
                //     size: 'small'
                //   },
                //   on: {
                //     click: () => {
                //       this.deleteDev(params.row.id)
                //     }
                //   }
                // }, '删除')
              ])
            }
          }
        }
      ],
      action: '',
      upFileList: false,
      tableData: [],
      total: 0,
      upgradeVersionNoList: [],
      upgradeVersionNo: '',
      deleteDevId: {},
      batchId: {
        ids: ''
      }
    }
  },
  created () {
    this.authList = getAuthStr()
    this.action = `${httpUrl.url}/manage/device/import`
    this.getPartnerNameList()
    this.getMerchantNameList()
    this.getVersionNoList()
    this.getFirmwareList()
    this.getDeviceInfo()
  },
  methods: {
    toAddDevice () {
      this.$router.push({
        path: '/add_device'
      })
    },
    getVersionNoList () {
      this.$axios.post(`${httpUrl.url}/manage/version/getList`, {})
        .then(res => {
          this.upgradeVersionNoList = res.data.data
        })
        .catch(errorHandler('获取数据失败'))
    },
    getFirmwareList () {
      this.$axios.post(`${httpUrl.url}/manage/version/getList`, {})
        .then(res => {
          let data = res.data.data
          data.map(v => {
            v.firmwareNo = v.versionNo
          })
          this.firewareList = data
        })
        .catch(errorHandler('获取版本列表失败'))
    },
    getPartnerNameList () {
      this.$axios.post(`${httpUrl.url}/manage/partner/getList`, {})
        .then(res => {
          this.partnerNameList = res.data.data
        })
        .catch(errorHandler('获取合作伙伴列表失败'))
    },
    getMerchantNameList () {
      this.$axios.post(`${httpUrl.url}/manage/merchant/getList`, {})
        .then(res => {
          this.merchantNameList = res.data.data
        })
        .catch(errorHandler('获取商户列表失败'))
    },
    // 导入
    beforeUpload () {},
    uploadSuccess () {
      nSuccess('导入成功')
      this.$refs.upload.clearFiles()
      this.reqbody.pageNo = 1
      this.getDeviceInfo()
    },
    // 导出
    exportDevice () {
      let exportUrl = `${httpUrl.url}/manage/device/export?deviceNo=${this.reqbody.deviceNo}&deviceStatus=${this.reqbody.deviceStatus}`
      this.downloadFile('', exportUrl)
    },
    downloadFile (fileName, href) {
      let eleLink = document.createElement('a')
      eleLink.download = fileName
      eleLink.style.display = 'none'
      eleLink.href = href
      eleLink.click()
    },
    getDeviceInfo () {
      let reqdata = this.reqbody
      if (reqdata.deviceStatus === '-1') {
        reqdata.deviceStatus = ''
      }
      this.$axios.post(`${httpUrl.url}/manage/device/getPage`, reqdata)
        .then(res => {
          let data = res.data.data
          if (this.authList.indexOf('001006') !== -1) {
            data.list.map(v => {
              v.authStatus = true
            })
          } else {
            data.list.map(v => {
              v.authStatus = false
            })
          }
          data.list.map(v => {
            if (v.scene === '1') {
              v.sceneText = '校园设备'
            } else if (v.scene === '2') {
              v.sceneText = '安徽电力设备'
            } else if (v.scene === '3') {
              v.sceneText = '社区设备'
            } else if (v.scene === '4') {
              v.sceneText = '渠道设备'
            } else if (v.scene === '5') {
              v.sceneText = '园区设备'
            } else {
              v.sceneText = '--'
            }
            if (v.devicePurpose === '1') {
              v.devicePurposeText = '门禁'
            } else {
              v.devicePurposeText = '停车'
            }
            if (v.serviceStartTime && v.serviceEndTime) {
              v.serviceTime = v.serviceStartTime + '至' + v.serviceEndTime
            } else {
              v.serviceTime = ''
            }
          })
          this.tableData = data.list
          this.total = data.total
        })
        .catch(errorHandler('获取数据失败'))
    },
    search () {
      this.reqbody.pageNo = 1
      this.getDeviceInfo()
    },
    setAllBatch (selection) {
      let idArr = []
      selection.map(v => {
        idArr.push(v.id)
      })
      this.batchId.ids = idArr.join(',')
    },
    setBatch (selection, row) {
      let idArr = []
      selection.map(v => {
        idArr.push(v.id)
      })
      this.batchId.ids = idArr.join(',')
    },
    delBatch (selection, row) {
      let idArr = []
      selection.map(v => {
        idArr.push(v.id)
      })
      this.batchId.ids = idArr.join(',')
    },
    batchDelete () {
      if (!this.batchId.ids) {
        nError('请先选择设备')
        return false
      }
      this.deleteDev(this.batchId.ids)
    },
    batchUpdata () {
      if (!this.batchId.ids) {
        nError('请先选择设备')
        return false
      }
      this.updataDev(this.batchId.ids)
    },
    deleteDev (id) {
      this.openSimple = true
      this.deleteDevId.ids = id.toString()
    },
    sureDelete () {
      this.$axios.post(`${httpUrl.url}/manage/device/deleteByIds`, this.deleteDevId)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('删除成功')
            this.openSimple = false
            this.reqbody.pageNo = 1
            this.getDeviceInfo()
          }
        })
        .catch(errorHandler('删除失败'))
    },
    cancelDelete () {
      this.openSimple = false
    },
    modifyDev (id) {
      this.$router.push({
        path: '/modify_device/' + id
      })
    },
    updataDev (id) {
      let status = true
      if (id.toString().indexOf(',') === -1) {
        this.tableData.map(v => {
          if (v.id.toString() === id.toString() && v.deviceStatus !== '1') {
            nError('离线设备不可升级')
            status = false
          }
        })
      } else {
        let idArr = id.split(',')
        idArr.map(v => {
          console.log(v)
          this.tableData.map(val => {
            if (val.id.toString() === v && val.deviceStatus !== '1') {
              nError('离线设备不可升级')
              status = false
            }
          })
        })
      }
      if (!status) {
        return false
      }
      this.updataSimple = true
      this.deleteDevId.ids = id.toString()
    },
    sureUpdata () {
      if (!this.upgradeVersionNo) {
        nError('请输入需要升级的版本')
        return false
      }
      this.$axios.post(`${httpUrl.url}/manage/device/upgrade`, {
        ids: this.deleteDevId.ids,
        versionNo: this.upgradeVersionNo
      })
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('升级成功')
            this.updataSimple = false
            this.upgradeVersionNo = ''
            this.getDeviceInfo()
          }
        })
        .catch(errorHandler('升级失败'))
    },
    cancelUpdata () {
      this.updataSimple = false
    },
    changePageNo (m) {
      this.reqbody.pageNo = m
      this.getDeviceInfo()
    },
    changePageSize (n) {
      this.reqbody.pageSize = n
      this.getDeviceInfo()
    }
  },
  watch: {
    searchDeviceStatus (v) {
      this.reqbody.deviceStatus = v
      this.reqbody.pageNo = 1
      this.getDeviceInfo()
    }
  }
}
</script>

<style scoped>
  .main {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }

  .main_right {
    min-width: 780px;
    height: 100%;
  }

  .breadcrumb {
    margin-bottom: 10px;
    border-left: 3px solid #00A0E6;
    padding-left: 5px;
  }

  .page_info {
    margin: 15px;
    background-color: #fff;
  }
  .searchBox, .operationBox {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .table_page {
    text-align: right;
    margin-top: 10px;
  }

  .reg-form {
    width: 520px;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/views/upgrade-management/upgrade-management.vue